export default __webpack_public_path__ + "static/media/ic_dashboard.b2592e31.png";